"use strict";

var _regeneratorRuntime = require("/codebuild/output/src042941679/src/CargoLink-Backoffice/node_modules/@babel/runtime/regenerator/index.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liffStub = void 0; // login status

var loginState = false;
var permanentLink = {
  createUrl: function createUrl() {
    return 'https://liff.line.me/liffId/path';
  },
  createUrlBy: function createUrlBy() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", 'https://liff.line.me/liffId/path');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  },
  setExtraQueryParam: function setExtraQueryParam() {}
};
exports.liffStub = {
  // LiffAPIs
  init: function init() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  },
  getOS: function getOS() {
    return 'web';
  },
  getVersion: function getVersion() {
    return '2.1.3';
  },
  getLanguage: function getLanguage() {
    return 'ja';
  },
  isInClient: function isInClient() {
    return true;
  },
  isLoggedIn: function isLoggedIn() {
    return loginState;
  },
  login: function login() {
    loginState = true;
  },
  logout: function logout() {
    loginState = false;
  },
  getAccessToken: function getAccessToken() {
    return 'DummyAccessToken';
  },
  getIDToken: function getIDToken() {
    return 'DummyIDToken';
  },
  getDecodedIDToken: function getDecodedIDToken() {
    return {
      amr: [],
      aud: 'aud',
      email: 'email@example.com',
      exp: 0,
      iat: 0,
      iss: 'iss',
      name: 'name',
      picture: 'picture_url',
      sub: 'sub'
    };
  },
  getContext: function getContext() {
    return {
      type: 'none',
      groupId: 'groupId',
      userId: 'userId',
      endpointUrl: 'endpointUrl',
      viewType: 'full',
      availability: {
        shareTargetPicker: {
          permission: false,
          minVer: '10.8.0'
        },
        multipleLiffTransition: {
          permission: false,
          minVer: '10.8.0'
        },
        subwindowOpen: {
          permission: false,
          minVer: '10.8.0'
        },
        scanCode: {
          permission: false,
          minVer: '10.8.0'
        },
        scanCodeV2: {
          permission: false,
          minVer: '10.8.0',
          minOsVer: '14.3.0'
        },
        getAdvertisingId: {
          permission: false,
          minVer: '10.8.0'
        },
        addToHomeScreen: {
          permission: false,
          minVer: '10.8.0'
        },
        bluetoothLeFunction: {
          permission: false,
          minVer: '10.8.0'
        },
        skipChannelVerificationScreen: {
          permission: false,
          minVer: '10.8.0'
        }
      },
      scope: []
    };
  },
  permission: {
    query: function query() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", {
                  state: 'granted'
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    requestAll: function requestAll() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  },
  openWindow: function openWindow(_ref) {
    var url = _ref.url,
        external = _ref.external;
    external ? window.open(url) : window.location.href = url;
  },
  closeWindow: function closeWindow() {
    window.close();
  },
  getFeatures: function getFeatures() {
    return [];
  },
  getFriendship: function getFriendship() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", {
                friendFlag: true
              });

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  },
  checkFeature: function checkFeature() {
    return true;
  },
  getAId: function getAId() {
    return undefined;
  },
  getProfilePlus: function getProfilePlus() {
    return undefined;
  },
  getIsVideoAutoPlay: function getIsVideoAutoPlay() {
    return true;
  },
  getLineVersion: function getLineVersion() {
    return '10.8.0';
  },
  isApiAvailable: function isApiAvailable() {
    return true;
  },
  getProfile: function getProfile() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", {
                displayName: 'displayName',
                pictureUrl: 'https://example.com/test.jpg',
                statusMessage: '',
                userId: 'userId'
              });

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
  },
  sendMessages: function sendMessages() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  },
  shareTargetPicker: function shareTargetPicker() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
  },
  subWindow: {
    on: function on() {},
    off: function off() {},
    open: function open() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    },
    cancel: function cancel() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", {
                  status: '200',
                  result: 'OK'
                });

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    },
    submit: function submit() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", {
                  status: '200',
                  result: 'OK'
                });

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    },
    close: function close() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    },
    getAppData: function getAppData() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", {});

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));
    }
  },
  isSubWindow: function isSubWindow() {
    return false;
  },
  permanentLink: permanentLink,
  ready: new Promise(function () {}),
  id: 'liffId',
  _dispatchEvent: function _dispatchEvent() {},
  _call: function _call() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));
  },
  _addListener: function _addListener() {},
  _removeListener: function _removeListener() {},
  _postMessage: function _postMessage() {},
  // LiffModules
  use: function use() {
    return exports.liffStub;
  },
  // Extras
  addToHomeScreen: function addToHomeScreen() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", 0);

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));
  },
  scanCode: function scanCode() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", {
                value: 'DummyCode'
              });

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));
  },
  scanCodeV2: function scanCodeV2() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", {
                value: 'DummyCode'
              });

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));
  },
  getAdvertisingId: function getAdvertisingId() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", null);

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));
  },
  initPlugins: function initPlugins() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", []);

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));
  }
};